// Port of api/fuel/app/classes/insights/player/wins.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function bucketIndex(value, edges) {
	value = parseFloat(value)
	if (value <= parseFloat(edges[0])) return 0
	if (value <= parseFloat(edges[1])) return 1
	if (value <= parseFloat(edges[2])) return 2
	return 3
}

function percentiles(values, ps) {
	var sorted = values.slice().sort(function(a, b) { return a - b })
	var n = sorted.length
	if (n === 0) return ps.map(function() { return 0 })
	return ps.map(function(p) {
		var rank = Math.max(0, Math.min(n - 1, Math.round((parseFloat(p) / 100) * (n - 1))))
		return sorted[rank]
	})
}

function buildWinRateGrid(opponents, opts) {
	opts = opts || {}
	var minGames = opts.min_games || 1
	var mode = opts.mode || 'percentile'
	var xEdges = opts.x_edges || [2, 5, 15]
	var yEdges = opts.y_edges || [0.25, 0.49, 0.75]

		if (mode === 'percentile') {
			var games = []
			for (var i = 0; i < opponents.length; i++) {
				var g = parseInt(opponents[i].plays, 10) || 0
				if (g >= minGames) {
					games.push(g)
				}
			}
			if (games.length) xEdges = percentiles(games, opts.percentiles_x || [25, 50, 75])
		}

	var counts = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]]
	var cells = [[[], [], [], []], [[], [], [], []], [[], [], [], []], [[], [], [], []]]

	for (var o = 0; o < opponents.length; o++) {
		var gamesPlayed = parseInt(opponents[o].plays, 10) || 0
		if (gamesPlayed < minGames) continue
		var rate = parseFloat(opponents[o].count) || 0
		if (rate < 0) rate = 0
		if (rate > 1) rate = 1
		var xi = bucketIndex(gamesPlayed, xEdges)
		var yi = bucketIndex(rate, yEdges)
		counts[yi][xi] += 1
		cells[yi][xi].push(opponents[o])
	}

	return {
		counts: counts,
		cells: cells,
		edges: { x: xEdges, y: yEdges }
	}
}

export default Segment.extend({
	name: 'wins',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['wins.band', 'wins.threshold'],
	detail: ['wins'],
	run: function(type, owner, userIndex, detail, filter) {
		var data = {
			list: [],
			grid: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
			total: 0
		}
		var band = (filter && filter['wins.band'] !== undefined) ? filter['wins.band'] : false
		var threshold = (filter && filter['wins.threshold'] !== undefined) ? parseInt(filter['wins.threshold'], 10) : 3
		var limit = detail ? 250 : 5
		var rawGames = {}
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (!rawGames[play.g]) {
				rawGames[play.g] = {
					id: parseInt(play.g, 10),
					plays: 0,
					self: 0,
					wins: 0
				}
			}
			rawGames[play.g].plays += play.c
			rawGames[play.g].wins += (this._data.player.plays[play.id] ? play.c : 0)
			rawGames[play.g].self += (this._data.self && this._data.self.plays[play.id] ? play.c : 0)
		}

		var games = []
		var rawGameKeys = Object.keys(rawGames)
		for (var rg = 0; rg < rawGameKeys.length; rg++) {
			var game = rawGames[rawGameKeys[rg]]
			if (game.plays > threshold) {
				var entry = {
					id: game.id,
					plays: game.plays,
					player: game.wins ? (1 / game.plays) * game.wins : 0,
					self: game.self ? (1 / game.plays) * game.self : 0,
					count: 0
				}
				var total = entry.self + entry.player
				var ratio = total === 0 ? 0.5 : (0.5 + (((entry.player / total) - 0.5) * total))
				entry.count = ratio
				games.push(entry)
			}
		}

		var gamesExtra = games.filter(function(game) { return game.count !== 0.5 })
		var raw = buildWinRateGrid(gamesExtra)

		data.grid[0] = raw.counts[3][0]
		data.grid[1] = raw.counts[3][1]
		data.grid[2] = raw.counts[2][0]
		data.grid[3] = raw.counts[2][1]
		data.grid[4] = raw.counts[3][2]
		data.grid[5] = raw.counts[3][3]
		data.grid[6] = raw.counts[2][2]
		data.grid[7] = raw.counts[2][3]
		data.grid[8] = raw.counts[1][0]
		data.grid[9] = raw.counts[1][1]
		data.grid[10] = raw.counts[0][0]
		data.grid[11] = raw.counts[0][1]
		data.grid[12] = raw.counts[1][2]
		data.grid[13] = raw.counts[1][3]
		data.grid[14] = raw.counts[0][2]
		data.grid[15] = raw.counts[0][3]

		if (band !== false && band !== null) {
			var map = [
				[3, 0], [3, 1], [2, 0], [2, 1],
				[3, 2], [3, 3], [2, 2], [2, 3],
				[1, 0], [1, 1], [0, 0], [0, 1],
				[1, 2], [1, 3], [0, 2], [0, 3]
			]
			var coords = map[parseInt(band, 10)]
			games = coords ? raw.cells[coords[0]][coords[1]] : games
		}

		data.total = games.length

		for (var gi = 0; gi < games.length; gi++) {
			var ratioValue = games[gi].count
			if (ratioValue >= 0.5) ratioValue -= 0.5
			else ratioValue = 0.5 - ratioValue
			games[gi].count = ratioValue
		}

		games = Util.sort_by_field(games, 'count', 'desc')
		if (games.length > limit) games = games.slice(0, limit)
		data.list = games

		for (var l = 0; l < data.list.length; l++) {
			data.list[l].player = data.list[l].player * 100
			data.list[l].self = data.list[l].self * 100
			this._references.games.push(parseInt(data.list[l].id, 10))
		}

		return {
			wins: data
		}
	}
})
